// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Image, Popup, Input, Button } from 'semantic-ui-react';
import { onlyNumberFilter } from 'app/lib/helper';
// local
import './PopupEditPrescription.scss';
// actions
import { updateAutoUpdate } from 'app/redux/actions/monitor';
// images
import ic_vertical_dots from 'app/_assets/img/ic_vertical_dots.png';
import ic_vertical_dots_white from 'app/_assets/img/ic_vertical_dots_white.png';

class PopupEditPrescription extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            prescription: props.prescription,
        };
    }

    onChange = (e, target) => {
        let { value } = target || e.target;
        value = value < 0 ? 0 : value;
        value = value > 20 ? 20 : value;
        if (value >= 0 && value <= 20) {
            this.setState({ prescription: value });
        }
    };

    onConfirmPopup = () => {
        const { onConfirmPopup } = this.props;
        if (onConfirmPopup) {
            onConfirmPopup(this.state.prescription);
        }
        this.handleClose();
    };

    onEditPatient = () => {
        const { onEditPatient, patientId } = this.props;
        if (onEditPatient) {
            onEditPatient(patientId);
        }
        this.handleClose();
    };

    handleOpen = () => {
        if (!this.state.isOpen) {
            this.props.dispatch(updateAutoUpdate(false));
            this.setState({ isOpen: true });
        }
    };

    handleClose = () => {
        if (this.state.isOpen) {
            this.setState({ isOpen: false });
        }
    };

    handleClickTrigger = e => {
        e.preventDefault();
        e.stopPropagation();
        this.handleOpen();
    };

    renderContent() {
        const { prescription } = this.state;
        return (
            <React.Fragment>
                <div className="title">LITRAGEM PRESCRITA</div>
                <div className="inputs">
                    <Input type="text" placeholder="0" value={prescription} onChange={onlyNumberFilter(this.onChange)} />
                    L/min
                </div>
                <Button content="Confirmar" className="highlight" onClick={this.onConfirmPopup} />
                <Button content="Editar Paciente" onClick={this.onEditPatient} />
            </React.Fragment>
        );
    }

    render() {
        const { isOpen } = this.state;
        const { inAlert } = this.props;
        const trigger = <Image src={inAlert ? ic_vertical_dots_white : ic_vertical_dots} className="popup-trigger" onClick={this.handleClickTrigger} />;
        return (
            <Popup
                id="popup-edit-prescription"
                open={isOpen}
                on="click"
                trigger={trigger}
                content={this.renderContent()}
                onClose={this.handleClose}
                onOpen={() => this.handleOpen}
                hoverable
                position="left center"
            />
        );
    }
}

PopupEditPrescription.propTypes = {
    dispatch: PropTypes.func.isRequired,
    patientId: PropTypes.number,
    prescription: PropTypes.number,
    inAlert: PropTypes.bool,
    onConfirmPopup: PropTypes.func,
    onEditPatient: PropTypes.func,
};

export default PopupEditPrescription;
